import React, { useState } from 'react'
import { ProductActions } from 'Stores/productStore'
import { Row, Col, Input } from 'reactstrap'
import 'react-image-crop/dist/ReactCrop.css'
import * as UTIF from 'utif'

export default function ProductImageUpload() {
  const [isUploading, setIsUploading] = useState(false)
  const onSelectFile = async e => {
    if (e.target.files && e.target.files.length > 0) {
      setIsUploading(true)
      for (const file of e.target.files) {
        const newImage = {
          BrandID: '',
          UserID: '',
          imageName: '',
          imageUID: '',
          imageOriginSource: '',
          imageOptimizedSource: '',
          imageOptimizedSourceMedium: '',
          imageOptimizedSourceSmall: '',
          imageCroppedSource: '',
          imageCroppedSourceMedium: '',
          imageCroppedSourceSmall: '',
          imageSizes: '',
          imageWidth: '',
          imageHeight: '',
          mime: '',
          timeInsert: new Date(),
          poolOrder: 0,
          fileName: file.name,
          imageBlob: await fileToImageBlob(file)
        }
        ProductActions.addAttachment(newImage)
      }
      setIsUploading(false)
    }
  }

  const fileToImageBlob = async file => {
    const fileName = file.name.toLowerCase()
    const mimeType = file.type

    const isTiff = mimeType === 'image/tiff' || mimeType === 'image/x-tiff' || fileName.endsWith('.tif') || fileName.endsWith('.tiff')

    if (isTiff) {
      return await convertTiffToImageBlob(file)
    } else if (mimeType.startsWith('image/')) {
      return file
    } else {
      console.error('Unsupported file type')
    }
  }

  const convertTiffToImageBlob = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()

      reader.onerror = () => reject('Failed to read file')

      reader.onload = () => {
        try {
          const buffer = reader.result

          const ifds = UTIF.decode(buffer)
          UTIF.decodeImage(buffer, ifds[0])

          const rgba = UTIF.toRGBA8(ifds[0])

          const canvas = document.createElement('canvas')
          canvas.width = ifds[0].width
          canvas.height = ifds[0].height

          const ctx = canvas.getContext('2d')
          const imageData = ctx.createImageData(canvas.width, canvas.height)
          imageData.data.set(rgba)
          ctx.putImageData(imageData, 0, 0)

          canvas.toBlob(blob => {
            if (!blob) {
              reject('Failed to create image blob')
              return
            }
            resolve(blob)
          }, 'image/png')
        } catch (err) {
          reject(err)
        }
      }

      reader.readAsArrayBuffer(file)
    })
  }

  return (
    <Row>
      <Col xs='2'>
        <label>Attachments</label>
      </Col>
      <Col xs='2'>
        <Input
          type='file'
          accept='image/*'
          onClick={e => (e.target.value = '') /*To enable uploading same image twice in a row*/}
          onChange={onSelectFile}
          disabled={isUploading}
          multiple
        />
      </Col>
    </Row>
  )
}
